/* eslint-disable @typescript-eslint/no-explicit-any */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { InitialStateInterface } from './types';

const MOTOBOY_INFO_INITIAL_STATE: InitialStateInterface = {
  data: '',
  fetching: false,
  payload: null,
  errors: [],
  dedicationFetching: false,
  dedication: null,
  dedicationErrors: [],
};

const motoboyInfoSlice = createSlice({
  name: 'motoboyInfo',
  initialState: MOTOBOY_INFO_INITIAL_STATE,
  reducers: {
    // TODO - Remove this action when refactor saga, this action is used only in saga
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    motoboyInfoRequest: (state, action: PayloadAction<string>) => {
      state.fetching = true;
      state.payload = null;
    },
    motoboyInfoSuccess: (state, action: PayloadAction<any>) => {
      state.fetching = false;
      state.errors = [];
      state.payload = action.payload;
    },
    motoboyInfoFailure: (state, action: PayloadAction<string[]>) => {
      state.fetching = false;
      state.errors = action.payload;
      state.payload = null;
    },
    // TODO - Remove this action when refactor saga, this action is used only in saga
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    motoboyDedicationRequest: (state, action: PayloadAction<string>) => {
      state.dedicationFetching = true;
      state.dedication = null;
    },
    motoboyDedicationSuccess: (
      state,
      action: PayloadAction<{ payload?: any; motoboyId?: string }>,
    ) => {
      state.dedicationFetching = false;
      state.errors = [];
      state.dedication = action.payload.payload;
      state.lastMotoboyIdDedication = action.payload.motoboyId;
    },
    motoboyDedicationFailure: (state, action: PayloadAction<string[]>) => {
      state.dedicationFetching = false;
      state.dedicationErrors = action.payload;
      state.payload = null;
    },
  },
});

export const {
  motoboyInfoRequest,
  motoboyInfoSuccess,
  motoboyInfoFailure,
  motoboyDedicationRequest,
  motoboyDedicationSuccess,
  motoboyDedicationFailure,
} = motoboyInfoSlice.actions;

export const motoboyInfoReducer = motoboyInfoSlice.reducer;
